export default __webpack_public_path__ + "static/media/endorsment-seal.a304f0f7.png";